// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2dWgE","hiddenElements":"Header_hiddenElements__2kVLF","search":"Header_search__1gD_F","dark":"Header_dark__3xKfo","wrapper":"Header_wrapper__1eRAT"};